import { render, staticRenderFns } from "./CopyCollectionIconDialog.vue?vue&type=template&id=b342da92&scoped=true"
import script from "./CopyCollectionIconDialog.vue?vue&type=script&lang=js"
export * from "./CopyCollectionIconDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b342da92",
  null
  
)

export default component.exports